import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';

import { GuestSaveStatus } from 'components';

const GuestSaveStatusContainer = props => <GuestSaveStatus {...props} />;

const mapStateToProps = (state, { id }) => ({
  guestSaveStatus: fromReservation.getGuestSaveStatus(state, id),
  cabinSaveStatusOut: fromReservation.getCabinSaveStatus(state, id, 'out'),
  cabinSaveStatusHome: fromReservation.getCabinSaveStatus(state, id, 'home'),
  requiredFieldsFilled: fromReservation.isGuestsRequiredFieldsFilled(state, id),
});

GuestSaveStatusContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(GuestSaveStatusContainer);



// WEBPACK FOOTER //
// ./src/containers/GuestSaveStatus.js